/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { Brand } from './Brand';
import {
    BrandFromJSON,
    BrandFromJSONTyped,
    BrandToJSON,
} from './Brand';
import type { DeviceInterfaceType } from './DeviceInterfaceType';
import {
    DeviceInterfaceTypeFromJSON,
    DeviceInterfaceTypeFromJSONTyped,
    DeviceInterfaceTypeToJSON,
} from './DeviceInterfaceType';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { QaEquipmentSubCategory } from './QaEquipmentSubCategory';
import {
    QaEquipmentSubCategoryFromJSON,
    QaEquipmentSubCategoryFromJSONTyped,
    QaEquipmentSubCategoryToJSON,
} from './QaEquipmentSubCategory';
import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';
import type { SingleDetectorConnectorType } from './SingleDetectorConnectorType';
import {
    SingleDetectorConnectorTypeFromJSON,
    SingleDetectorConnectorTypeFromJSONTyped,
    SingleDetectorConnectorTypeToJSON,
} from './SingleDetectorConnectorType';

/**
 * 
 * @export
 * @interface CreateUnicheckDeviceDto
 */
export interface CreateUnicheckDeviceDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUnicheckDeviceDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUnicheckDeviceDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof CreateUnicheckDeviceDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUnicheckDeviceDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUnicheckDeviceDto
     */
    imageId?: string | null;
    /**
     * 
     * @type {QaEquipmentSubCategory}
     * @memberof CreateUnicheckDeviceDto
     */
    subCategory: QaEquipmentSubCategory;
    /**
     * 
     * @type {RtSystemManufacturer}
     * @memberof CreateUnicheckDeviceDto
     */
    manufacturer: RtSystemManufacturer;
    /**
     * 
     * @type {string}
     * @memberof CreateUnicheckDeviceDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUnicheckDeviceDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUnicheckDeviceDto
     */
    typeNumber?: string | null;
    /**
     * 
     * @type {Brand}
     * @memberof CreateUnicheckDeviceDto
     */
    brand1?: Brand;
    /**
     * 
     * @type {DeviceInterfaceType}
     * @memberof CreateUnicheckDeviceDto
     */
    deviceInterfaceType?: DeviceInterfaceType;
    /**
     * 
     * @type {string}
     * @memberof CreateUnicheckDeviceDto
     */
    defaultImageId?: string | null;
    /**
     * 
     * @type {SingleDetectorConnectorType}
     * @memberof CreateUnicheckDeviceDto
     */
    singleDetectorConnectorType?: SingleDetectorConnectorType;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUnicheckDeviceDto
     */
    isRegistrable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUnicheckDeviceDto
     */
    serialNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUnicheckDeviceDto
     */
    dpin: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUnicheckDeviceDto
     */
    $type?: CreateUnicheckDeviceDtoTypeEnum;
}


/**
 * @export
 */
export const CreateUnicheckDeviceDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDeviceComponentDtoCreateUnicheckDeviceDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreateUnicheckDeviceDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateUnicheckDeviceDtoTypeEnum = typeof CreateUnicheckDeviceDtoTypeEnum[keyof typeof CreateUnicheckDeviceDtoTypeEnum];


/**
 * Check if a given object implements the CreateUnicheckDeviceDto interface.
 */
export function instanceOfCreateUnicheckDeviceDto(value?: unknown): value is CreateUnicheckDeviceDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateUnicheckDeviceDtoTypeEnum)[0];
}

export function CreateUnicheckDeviceDtoFromJSON(json: any): CreateUnicheckDeviceDto {
    return CreateUnicheckDeviceDtoFromJSONTyped(json, false);
}

export function CreateUnicheckDeviceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUnicheckDeviceDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isAvailable': !exists(json, 'isAvailable') ? undefined : json['isAvailable'],
        'imageId': !exists(json, 'imageId') ? undefined : json['imageId'],
        'subCategory': QaEquipmentSubCategoryFromJSON(json['subCategory']),
        'manufacturer': RtSystemManufacturerFromJSON(json['manufacturer']),
        'model': json['model'],
        'subModel': !exists(json, 'subModel') ? undefined : json['subModel'],
        'typeNumber': !exists(json, 'typeNumber') ? undefined : json['typeNumber'],
        'brand1': !exists(json, 'brand1') ? undefined : BrandFromJSON(json['brand1']),
        'deviceInterfaceType': !exists(json, 'deviceInterfaceType') ? undefined : DeviceInterfaceTypeFromJSON(json['deviceInterfaceType']),
        'defaultImageId': !exists(json, 'defaultImageId') ? undefined : json['defaultImageId'],
        'singleDetectorConnectorType': !exists(json, 'singleDetectorConnectorType') ? undefined : SingleDetectorConnectorTypeFromJSON(json['singleDetectorConnectorType']),
        'isRegistrable': !exists(json, 'isRegistrable') ? undefined : json['isRegistrable'],
        'serialNumber': json['serialNumber'],
        'dpin': json['dpin'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateUnicheckDeviceDtoToJSON(value?: CreateUnicheckDeviceDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value.name,
        'description': value.description,
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isAvailable': value.isAvailable,
        'imageId': value.imageId,
        'subCategory': QaEquipmentSubCategoryToJSON(value.subCategory),
        'manufacturer': RtSystemManufacturerToJSON(value.manufacturer),
        'model': value.model,
        'subModel': value.subModel,
        'typeNumber': value.typeNumber,
        'brand1': BrandToJSON(value.brand1),
        'deviceInterfaceType': DeviceInterfaceTypeToJSON(value.deviceInterfaceType),
        'defaultImageId': value.defaultImageId,
        'singleDetectorConnectorType': SingleDetectorConnectorTypeToJSON(value.singleDetectorConnectorType),
        'isRegistrable': value.isRegistrable,
        'serialNumber': value.serialNumber,
        'dpin': value.dpin,
        '$type': value.$type,
    });
}

